"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var empTagApi = _interopRequireWildcard(require("@/api/empTagApi.js"));
var _validate = require("@/utils/validate");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'EditTag',
  data: function data() {
    return {
      loading: false,
      visible: false,
      formData: {
        tagName: ''
      },
      editId: null,
      rules: {
        tagName: [{
          required: true,
          message: '请输入标签名称',
          trigger: ['blur', 'change']
        }]
      }
    };
  },
  methods: {
    openInit: function openInit(row) {
      var _this = this;
      this.editId = row.id || null;
      this.formData = {
        tagName: row.tagName || ''
      };
      this.visible = true;
      this.$nextTick(function () {
        if (_this.$refs.form) {
          _this.$refs.form.clearValidate();
        }
      });
    },
    handleSubmit: (0, _validate.Debounce)(function () {
      var _this2 = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        _this2.loading = true;
        var params = {
          tagName: _this2.formData.tagName
        };
        if (_this2.editId) {
          params.id = _this2.editId;
        }
        var apiMethod = _this2.editId ? empTagApi.updateTag : empTagApi.addTag;
        apiMethod(params).then(function () {
          _this2.$message.success('操作成功');
          _this2.loading = false;
          _this2.visible = false;
          _this2.$emit('doRefresh');
        }).catch(function () {
          _this2.loading = false;
        });
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    }
  }
};